module.exports = __webpack_public_path__ + "img/I+D+I_Build.064a33e4.png";